export default "__VITE_ASSET__Cvnv5fFB__"